module.exports = __webpack_public_path__ + "img/chinese.442b3e38.png";